import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PatientCardStyle from './DoctorCard.module'; // you can rename style file later
import { motion } from 'framer-motion';
import { app_paths, departmentLabel, divisionLabel } from '../../config/variables';

const DoctorCard = ({ doctor }) => {
  const classes = PatientCardStyle();
  const navigate = useNavigate();

  // Extract doctor information
  const doctorName = doctor.user?.name || 'Unknown Doctor';
  const doctorGender = doctor.user?.gender || 'N/A';
  const doctorAge = doctor.user?.age || 'N/A';
  const doctorId = doctor.id || '';

  const department = doctor.department || 'N/A';
  const division = doctor.division || 'N/A';
  const license = doctor.license || 'N/A';

  // Initials for avatar
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name[0].toUpperCase();
  };

  const handleCardClick = () => {
    navigate(`${app_paths.DOCTOR_PROFILE_FOR_FACILITY.replace(':doctorID', doctorId)}`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Box sx={classes.card} onClick={handleCardClick}>
        <Box sx={classes.cardContent}>

          {/* Avatar */}
          <Box sx={classes.avatar}>
            {getInitials(doctorName)}
          </Box>

          {/* Doctor Information */}
          <Box sx={classes.infoSection}>
            <Typography sx={classes.patientName}>
              {doctorName}
            </Typography>

            <Box sx={classes.infoRow}>
              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Gender</Typography>
                <Typography sx={classes.value}>
                  {doctorGender === 'F' ? 'Female' : doctorGender === 'M' ? 'Male' : doctorGender}
                </Typography>
              </Box>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Age</Typography>
                <Typography sx={classes.value}>
                  {doctorAge !== 'N/A' ? `${doctorAge} years` : 'N/A'}
                </Typography>
              </Box>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>License</Typography>
                <Typography sx={classes.value}>{license}</Typography>
              </Box>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Department</Typography>
                <Typography sx={classes.value}>{departmentLabel[department]}</Typography>
              </Box>

              <Box sx={classes.infoItem}>
                <Typography sx={classes.label}>Division</Typography>
                <Typography sx={classes.value}>{divisionLabel[division]}</Typography>
              </Box>

            </Box>
          </Box>
        </Box>
      </Box>
    </motion.div>
  );
};

export default DoctorCard;
